<app-chart-wrapper [title]="'Portfolio-at-Risk'" [showValuePercentToggle]="true" [showExpandIcons]="false">
    <app-chart-filter filter [form]="portfolioForm" [formControls]="portfolioFormControls" (filter)="filterPAR($event)"></app-chart-filter>
    <app-doughnut-chart chart></app-doughnut-chart>
</app-chart-wrapper>